import axios from 'axios';

const API_LOGIN_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const getMyInvites = async (token) => {
    const response = await axios.get(`${API_LOGIN_URL}/invites/my`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

const grantInvites = async (token, userId, amount) => {
    const response = await axios.post(`${API_LOGIN_URL}/invites/grant`, { userId, amount }, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

const inviteService = {
    getMyInvites,
    grantInvites
};

export default inviteService;
